import axios from 'axios-typescript';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const CLASSIFICATION_URL = process.env.REACT_APP_CLASSIFICATION_URL;

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_TOKEN}`
  },
});

const apiBucket = axios.create({
  baseURL: CLASSIFICATION_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_TOKEN}`
  },
});

// Define common API methods
const _get = (url: string, config = {}) => {
  return apiClient.get(url, config);
};

const _delete = (url: string, config = {}) => {
  return apiClient.delete(url, config);
};

const _put = (url: string, data = {}) => {
  return apiClient.put(url, data);
};

const _post = (url: string, data = {}) => {
  return apiClient.post(url, data);
};

const _postBucket = (url: string, data: any = []) => {
  return apiBucket.post(url, data);
};

const _getBucketResult = (url: string, config: any = {}) => {
  return apiBucket.get(url, config);
};
// Export API method
export { _get, _delete, _put, _post, _postBucket, _getBucketResult };